export const tableActionsOptions = [
  {
    action: 'details',
    label: 'Detalhes',
    resource: 'general|collect|delivery',
    isEditableFor: 'collect-units',
    onClick: () => {}
  },
  {
    action: 'files',
    label: 'Arquivos',
    resource: 'general|collect|delivery',
    onClick: () => {}
  },
  {
    action: 'operatorAccess',
    label: 'Acesso à operadora',
    resource: 'collect-units',
    onClick: () => {}
  },
  {
    action: 'reject',
    label: 'Recusar',
    resource: 'collect-units',
    onClick: () => {}
  },
  {
    action: 'downloadReport',
    label: 'Baixar',
    resource: 'report-units',
    onClick: () => {}
  },
  {
    action: 'remove',
    label: 'Remover',
    resource: 'general',
    onClick: () => {}
  }
]
